<template>
	<input type="radio" 
		:id="id" 
		:name="name" 
		:class="['c-input-radio', 'c-input-radio-native-style', cssClass, isValid == false ? 'is-invalid' : '']" 
		:value="optionValue" 
		:checked="modelValue == optionValue"
		@change="handleChange"
	>

	<span class="validation-text" v-if="isValid == false && validationMessage != ''">
		<small style="color: red" v-html="validationMessage"></small>
	</span>
</template>





<script>
import allFormElementPropsMixin from "./all-form-element-props-mixin";

export default {


	emits: ["change", "select", "update:modelValue"],


	mixins: [allFormElementPropsMixin],

	props: {

		//TODO: Obsolete/deprecated. Don't remove until removing from implementations.
		initialValue: {
			type: String
		},



		/**
		 * [Required] The value associated with this radio button.
		 */
		optionValue: {
			type: String
		},



        modelValue: {
            type: [String, null],
            default: '',
            required: true
        },



		type: {
			type: String,
			default: "element"
		},

	},





	data()
	{
		return {
			// value: false
		};
	},





	mounted()
	{
	},





	watch: {
	},





	computed: {
		getName() {
			return this.name ? this.name : this.id;
		}
	},





	methods: {

		handleChange($event)
		{
			this.$emit('change', this.optionValue);
			this.$emit('select', this.optionValue);

			this.$emit('update:modelValue', this.optionValue);
		},

	}
}
</script>





<style scoped lang="scss">
	@use "/assets/sass/_global.scss" as *;
</style>


<style>
	/**
	Hide the label auto-generated by the Element control
	*/
	.el-radio__label
	{
		display: none;
		visibility: hidden;
	}



	.c-input-radio-native-style
	{
		/* Double-sized Checkboxes */
		-ms-transform: scale(1.2); /* IE */
		-moz-transform: scale(1.2); /* FF */
		-webkit-transform: scale(1.2); /* Safari and Chrome */
		-o-transform: scale(1.2); /* Opera */
		transform: scale(1.2);
	}
</style>